function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M72 0C32.256 0 0 32.256 0 72C0 111.744 32.256 144 72 144C111.744 144 144 111.744 144 72C144 32.256 111.744 0 72 0ZM72 129.6C40.248 129.6 14.4 103.752 14.4 72C14.4 40.248 40.248 14.4 72 14.4C103.752 14.4 129.6 40.248 129.6 72C129.6 103.752 103.752 129.6 72 129.6ZM99.936 45.288L57.6 87.624L44.064 74.088C42.7178 72.7418 40.8919 71.9855 38.988 71.9855C37.0841 71.9855 35.2582 72.7418 33.912 74.088C32.5658 75.4342 31.8095 77.2601 31.8095 79.164C31.8095 81.0679 32.5658 82.8938 33.912 84.24L52.56 102.888C55.368 105.696 59.904 105.696 62.712 102.888L110.16 55.44C110.827 54.7739 111.357 53.9827 111.718 53.1117C112.08 52.2407 112.266 51.307 112.266 50.364C112.266 49.421 112.08 48.4873 111.718 47.6163C111.357 46.7453 110.827 45.9541 110.16 45.288C107.352 42.48 102.744 42.48 99.936 45.288Z",
  fill: "white"
});

var SvgUploadDoneIcon = function SvgUploadDoneIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 144 144",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUploadDoneIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload-done-icon.1bccd50e.svg";
export { ForwardRef as ReactComponent };